export default __webpack_public_path__ + "static/media/searchMovie.c72dbc1e.png";